import { Chip, ChipProps } from "@mui/material";
import { CheckCircleOutline, BlockOutlined, PauseCircleOutline, Business, InventoryOutlined } from "@mui/icons-material";
import palette from "@/palette";

type CustomChipProps = {
  label: string;
  status: "positive" | "negative" | "neutral";
  type: "status" | "tag" | "company" | "collection";
} & ChipProps;

const CustomChip = ({ label, status, type, ...props }: CustomChipProps) => {

  const color = type === "status" ? (status === "positive" ? (palette.dark.success.dark ) : status === "negative" ? (palette.dark.error.main) : "default") : (palette.dark.primary.main);
  const icon: ChipProps["icon"] = type === "status" ? (status === "positive" ? (
    <CheckCircleOutline
      sx={{
        fill: color,
      }}
    />
  ) : status === "negative" ? (
    <BlockOutlined color="action" sx={{ fill: color }}/>
  ) : (
    <PauseCircleOutline color="action" sx={{ fill: color }}/>
  )) : type === "company" ? (
    <Business color="action" sx={{ fill: color }}/>
  ) : type === "collection" ? (
    <InventoryOutlined color="action" sx={{ fill: color }}/>
  ) : undefined;

  return (
    label && <Chip
      {...props}
      label={label}
      size="small"
      sx={{
        borderColor: color,
        color: type === 'company' || type === 'collection' ? "text.secondary" : color,
        paddingLeft: type === 'company' || type === 'collection' ? 0.5 : 0,
        paddingBlock: type === 'collection' ? 0.5 : 0,
        ...props.sx,
      }}
      icon={type === "tag" ? undefined : icon}
      variant="outlined"
    />
  );
}
export default CustomChip